import { useEnrollmentStore } from '@/stores'
import type { EligibilityFormData } from '../../components/eligibilitySteps/types'
import type {
  BuildEnrollmentDraftStorePatchOptions,
  HydrationResult
} from './types'

export const buildEnrollmentDraftStorePatch = (
  formData: EligibilityFormData,
  options?: BuildEnrollmentDraftStorePatchOptions
) => {
  const patch = {
    email: formData.email,
    dateOfBirth: formData.dateOfBirth,
    zipCode: formData.zipCode,
    licenseNumber: formData.driverLicenseNumber,
    licenseState: formData.driverLicenseState,
    licenseExpiration: formData.licenseExpirationDate,
    transmissionType: formData.transmissionType,
    emergencyContactName: formData.emergencyContactName,
    emergencyContactPhone: formData.emergencyContactPhone
  }

  if (!options?.includeSelection) {
    return patch
  }

  return {
    ...patch,
    locationExternalId: formData.location,
    programExternalId: formData.selectedProgram,
    locationState: options.locationState ?? ''
  }
}

export const persistEnrollmentHydration = (
  formData: EligibilityFormData,
  _result: HydrationResult
) => {
  if (typeof window === 'undefined') return

  useEnrollmentStore.getState().updateFormData(
    buildEnrollmentDraftStorePatch(formData, {
      includeSelection: true,
      locationState: useEnrollmentStore.getState().formData.locationState
    })
  )
}
